import { Link } from "react-router-dom";

const stats = [
  { value: "20+", label: "Années sur le terrain" },
  { value: "500+", label: "Salles de bain posées" },
  { value: "9", label: "Localités qu'on connaît par cœur" },
  { value: "0", label: "Carreaux coupés au hasard" },
];

export default function AboutSection() {
  return (
    <section className="py-24 bg-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <span className="inline-block px-3 py-1 bg-amber-700/20 text-amber-400 text-xs font-medium tracking-widest uppercase rounded-full mb-4">
              Qui sommes-nous
            </span>
            <h2 className="text-4xl font-bold leading-tight mb-6">
              Du carrelage fait main,<br />
              <span className="text-amber-400">à la valaisanne</span>
            </h2>
            <p className="text-stone-300 text-sm leading-relaxed mb-4">
              On n'est pas une grande boîte avec un service marketing derrière. Carreaux-Bat, c'est avant tout des mains qui savent poser un carreau droit et des yeux qui voient quand un joint dévie d'un millimètre. Depuis plus de 20 ans, on trace nos routes entre Sion, Sierre et les villages alentours. Vous cherchez un carreleur à proximité ? On est là, à Grône, et on intervient dans toute votre région.
            </p>
            <p className="text-stone-300 text-sm leading-relaxed mb-4">
              Pose de carrelage sur sols et murs, rénovation complète de salles de bain, douche à l'italienne — on ne promet pas la lune, on promet juste un boulot propre et des finitions qui tiennent le coup. Les joints droits, la pente bien calculée, le carrelage qui ne se soulève pas au premier hiver. C'est comme ça qu'on a construit notre réputation, chantier après chantier, près de chez vous.
            </p>
            <p className="text-stone-300 text-sm leading-relaxed mb-8">
              On intervient dans toute la région du Valais central : <strong className="text-white">Sion, Sierre, Martigny, Grône, Crans-Montana, Verbier, Nendaz, Vercorin et Nax</strong>. Que ce soit pour une petite rénovation d'une salle de bain ou une pose complète de carrelage sur une surface de plusieurs dizaines de mètres carrés, on adapte notre méthode à chaque chantier. Du carrelage classique aux mosaïques, du sol chauffant aux douches à l'italienne avec receveur sur mesure — on maîtrise chaque étape, de la préparation du support à la pose finale. Besoin d'un carreleur à proximité ? Appelez-nous, on vient vous voir sur place.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/services"
                className="px-6 py-3 bg-amber-700 text-white text-sm font-medium rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap"
              >
                Voir nos services
              </Link>
              <Link
                to="/contact"
                className="px-6 py-3 border border-stone-600 text-stone-300 text-sm font-medium rounded-full hover:border-amber-600 hover:text-amber-400 transition-colors whitespace-nowrap"
              >
                Demander un devis
              </Link>
            </div>
          </div>

          {/* Right */}
          <div>
            <div className="relative">
              <img
                src="/images/about.jpg"
                alt="Pose de carrelage artisanal Carreaux-Bat"
                className="w-full h-80 object-cover object-top rounded-lg"
              />
              <div className="absolute -bottom-6 -left-6 bg-amber-700 rounded-lg p-5 shadow-lg">
                <p className="text-3xl font-bold text-white">20+</p>
                <p className="text-xs text-amber-200 mt-1">Années d'expérience</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-12">
              {stats.slice(1).map((stat) => (
                <div key={stat.label} className="bg-stone-800 rounded-lg p-5">
                  <p className="text-2xl font-bold text-amber-400">{stat.value}</p>
                  <p className="text-xs text-stone-400 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}